export default __webpack_public_path__ + "static/dinar-8bdf0b3678156e7a0e41b91b64075e1a.jpeg";